import React from 'react';

const Locations = ({ onOpenModal }) => {
  const dallasAreas = [
    { name: 'Downtown Dallas', image: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=200&q=80' },
    // Replaced Uptown image
    { name: 'Uptown', image: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=200&q=80' },
    { name: 'Plano', image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=200&q=80' },
    { name: 'Frisco', image: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=200&q=80' },
    { name: 'Irving', image: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=200&q=80' },
    { name: 'Garland', image: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=200&q=80' },
    // Replaced Richardson image
    { name: 'Richardson', image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=200&q=80' },
    // Replaced Allen image
    { name: 'Allen', image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=200&q=80' },
    { name: 'McKinney', image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=200&q=80' },
    { name: 'Carrollton', image: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=200&q=80' },
    { name: 'Lewisville', image: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=200&q=80' },
    { name: 'Denton', image: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=200&q=80' },
  ];

  return (
    <section id="locations" className="py-20 bg-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-propwhiz-dark mb-4">
            We Buy Houses Across Dallas-Fort Worth
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From Downtown to the suburbs, we're here to help Dallas homeowners.
          </p>
        </div>

        {/* Dallas Hero Image */}
        <div className="relative h-64 md:h-96 rounded-3xl overflow-hidden mb-12">
          <img 
            src="https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" 
            alt="Dallas Skyline" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end">
            <h3 className="text-white text-3xl md:text-4xl font-bold p-8">Dallas-Fort Worth Metroplex</h3>
          </div>
        </div>

        {/* Dallas Areas Grid with Images */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {dallasAreas.map((area) => (
            <div
              key={area.name}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 h-64"
            >
              <img 
                src={area.image} 
                alt={area.name}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="text-white text-2xl font-bold mb-1">{area.name}</h3>
                <p className="text-white/80 text-sm">We buy houses here</p>
              </div>
              <div className="absolute top-4 right-4 bg-propwhiz-accent text-white px-3 py-1 rounded-full text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                Cash Offers
              </div>
            </div>
          ))}
        </div>

        {/* Dallas Service Area Note */}
        <div className="bg-gradient-to-r from-propwhiz-blue to-propwhiz-accent rounded-3xl p-8 text-white text-center">
          <div className="flex items-center justify-center gap-4 mb-4">
            <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
            </svg>
            <h3 className="text-2xl font-bold">100% Dallas-Focused</h3>
          </div>
          <p className="text-lg opacity-90 mb-6">
            We specialize in Dallas properties. If you're in the DFW area, we're ready to make you a fair cash offer.
          </p>
          <button 
            onClick={onOpenModal} 
            className="bg-white text-propwhiz-blue px-8 py-3 rounded-full font-bold hover:bg-gray-100 transition transform hover:scale-105"
          >
            Get Your Dallas Offer
          </button>
        </div>
      </div>
    </section>
  );
};

export default Locations;